/** @format */

import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { IHeaderSearch } from '../../_classes/header-search';
import { EquipmentRequestDatagridComponent } from './equipment-request-datagrid.component';

@Component({
  selector: 'app-equipment-request-datagrid-modal',
  standalone: true,
  imports: [CommonModule, IonicModule, EquipmentRequestDatagridComponent],
  template: `
    <ion-header>
      <ion-toolbar>
        <ion-title>Demande d'ajout d'un équipement</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="dismiss()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content scroll-y="false">
      <app-equipment-request-datagrid id="content" [filter]="filter"></app-equipment-request-datagrid>
    </ion-content>
  `,
  styleUrls: ['./equipment-request-datagrid-modal.component.scss'],
})
export class EquipmentDatagridModalComponent {
  @Input()
  filter!: IHeaderSearch;

  constructor(private modalCtrl: ModalController) {}

  dismiss() {
    return this.modalCtrl.dismiss();
  }
}
